import axios from 'axios'

// Staff notes about a user, general or on one hold. See
// api-laravel/app/Services/UserComments.php for who may read and write which.
export default {

    // { comments, targets }. With group_id: that hold's notes and the
    // general notes of its school, as the hold's member list shows them.
    async fetchComments({ user_id, group_id }) {
        return await axios.get(`/user/${user_id}/comments`, {
            params: group_id ? { group_id } : {}
        })
    },

    // { [user_id]: count } for the hold's members and dropouts.
    async fetchCommentCounts(group_id) {
        return await axios.get(`/members/${group_id}/comment-counts`)
    },

    // A hold's note: { group_id }. A general note: { group_id: null, institution_id }.
    async addComment({ user_id, text, group_id, institution_id }) {
        return await axios.post(`/user/${user_id}/comments`, {
            text,
            group_id: group_id || null,
            institution_id: group_id ? undefined : institution_id
        })
    },

    async updateComment({ id, text }) {
        return await axios.put(`/user/comments/${id}`, { text })
    },

    async deleteComment(id) {
        return await axios.delete(`/user/comments/${id}`)
    },
}
